/**
 * Baut einen Universal-Deep-Link fuer die Routenfuehrung in
 * Apple Maps / Google Maps, ausgehend vom aktuellen Standort des
 * Geraets, ueber alle Tour-Stopps in Reihenfolge.
 *
 * Das Format
 *   https://www.google.com/maps/dir/?api=1&origin=My+Location&waypoints=...&destination=...&travelmode=driving
 * funktioniert auf:
 *   - iOS (iPhone): oeffnet die Google-Maps-App, falls installiert,
 *     sonst den Browser. Apple Maps versteht auch eine maps://-Variante,
 *     aber Google-Maps-Format ist breiter unterstuetzt.
 *   - Android: oeffnet Google Maps direkt
 *   - Mac/Desktop: oeffnet im Browser, von dort kann ueber das Teilen-
 *     Menue der Link aufs Handy weitergegeben werden
 *
 * `origin=My+Location` ist Google-Maps-eigene Magie fuer "aktueller
 * GPS-Standort des Geraets".
 *
 * Fallback: wenn keine sinnvollen Stopps geliefert werden, gibt's null
 * zurueck — der Aufrufer soll den Knopf dann disabled rendern.
 */

const MAX_WAYPOINTS = 9;   // Google-Maps-Limit fuer Direktions-Links

function adresseFuerLink(tk) {
  // Wir bevorzugen die echte Adresse (Strasse + PLZ + Ort), weil das
  // bei Apple/Google Maps zur Hausnummern-genauen Routenfuehrung fuehrt.
  // Falls keine Strasse vorhanden ist (Booking-Widget-Kunden), nehmen
  // wir die Koordinaten direkt — das landet im PLZ-Bereich.
  const teile = [tk.kunde_strasse, tk.kunde_plz, tk.kunde_ort, 'Deutschland']
    .filter(t => t && String(t).trim());
  if (teile.length >= 2) {
    return teile.join(', ');
  }
  if (typeof tk.kunde_lat === 'number' && typeof tk.kunde_lng === 'number') {
    return `${tk.kunde_lat},${tk.kunde_lng}`;
  }
  return null;
}

export function baueRoutenLink(tourKunden) {
  const stopps = (tourKunden || [])
    .map(adresseFuerLink)
    .filter(Boolean);
  if (stopps.length === 0) return null;

  // Letzten Stopp als destination, alle davor als waypoints
  const destination = stopps[stopps.length - 1];
  const waypoints = stopps.slice(0, -1).slice(0, MAX_WAYPOINTS);

  const params = new URLSearchParams({
    api: '1',
    origin: 'My Location',
    destination,
    travelmode: 'driving',
  });
  if (waypoints.length > 0) {
    // URLSearchParams kodiert das | nicht — bewusst, weil Google das
    // genau in dieser Form erwartet.
    params.set('waypoints', waypoints.join('|'));
  }
  return `https://www.google.com/maps/dir/?${params.toString()}`;
}

/**
 * Anzahl der "fahrbaren" Stopps fuer den Knopf-Hinweis.
 */
export function anzahlStoppsMitAdresse(tourKunden) {
  return (tourKunden || []).filter(adresseFuerLink).length;
}
